import Decorate from '@tencent/spaui-decorate';
import { Dialog, DialogProps } from '@tencent/spaui';
import _ from 'lodash';
import { SITE } from '@/constants/config.js';
import { logout } from './logout';

const defaultOptions = {
  useNewUI: true,
  closeButton: true,
  cancelButton: true,
  submitLabel: '确定',
  className: '',
};

export const genMsgFun = (typeOptions: any = {}) => (children: any, options: DialogProps = {}) => {
  const dialog = new Decorate(Dialog);
  const _options = {
    ...defaultOptions,
    ...typeOptions,
    ...options,
  };
  const { needReject = false } = _options;
  return new Promise((resolve, reject) => {
    dialog.setProps({
      show: true,
      title: '提示',
      children,
      ..._options,
      onClose() {
        if (_.isFunction(_options.onClose)) {
          _options.onClose();
        }
        dialog.destroy();
        needReject && reject();
      },
      onCancel() {
        if (_.isFunction(_options.onCancel)) {
          _options.onCancel();
        }
        dialog.destroy();
        needReject && reject();
      },
      onSubmit: () => {
        if (_.isFunction(_options.onSubmit)) {
          _options.onSubmit();
        }
        dialog.destroy();
        resolve(null);
      },
    });
  });
};

const loadingDialog = new Decorate(Dialog);

const showLoading = (message: any, options = {}) => {
  loadingDialog.setProps({
    show: true,
    children: message,
    type: 'tip',
    iconType: 'loading',
    ...options,
  });
};

const hideLoading = () => {
  loadingDialog.setProps({
    show: false,
  });
};

const goQQLogin = function () {
  const url = `${SITE.ssoUrl}?sso_redirect_uri=${encodeURIComponent(location.href)}&service_tag=2`;
  window.location.replace(url);
};

const goWXLogin = function () {
  const url = `https://sso.e.qq.com/login/hub?sso_redirect_uri=${encodeURIComponent(location.href)}&service_tag=10&display_login=wx`;
  logout(url);
};

const goMktAuth = function () {
  const url = `https://e.qq.com/agp/auth/get_mkt_auth_url?redirect_uri=${encodeURIComponent(location.href)}`;
  window.location.replace(url);
};

let dialog: any = null;
export const handleErrResponse = function (response: any, errInfo?: any) {
  // 全局的异常弹窗，只允许有一个。
  if (dialog) {
    // 如果存在旧的，立即移除，不播放动画
    dialog.destroy();
    dialog = null;
  }
  dialog = new Decorate(Dialog);

  // 移除Dialog
  function removeDialog() {
    dialog.setProps({
      show: false,
    });
    setTimeout(() => {
      // 执行完动画再销毁
      dialog.destroy();
      dialog = null;
    }, 1000);
  }

  const { code = '', msg = '', message: agsMessage = '', exception = {}, trace_id } = response;

  const message = msg || agsMessage || exception.message || errInfo;

  const dialogConfig = {
    useNewUI: true,
    show: true,
    title: '错误提示',
    type: 'normal',
    size: 'large',
    backdrop: true,
    enabledBackdropClose: true,
    children: (
      <div className="dialog-err">
        <span>{message}</span>
        {trace_id ? <span>{`trace_id：${trace_id}`}</span> : null}
      </div>
    ),
    cancelButton: false,
    onClose: () => {
      dialog.setProps({
        show: false,
      });
    },

  };
  switch (code) {
    case 200000:
      dialog.setProps({
        ...dialogConfig,
        onSubmit: goQQLogin,
      });
      break;
    case 200001:
      dialog.setProps({
        ...dialogConfig,
        onSubmit: goWXLogin,
      });
      break;
    case 200010:
      dialog.setProps({
        ...dialogConfig,
        onSubmit: goMktAuth,
      });
      break;
    case 301:
      dialog.setProps({
        ...dialogConfig,
        children: (
          <div
            dangerouslySetInnerHTML={{
              __html: `${message}`,
            }}
          ></div>
        ),
        onSubmit: removeDialog,
        onClose: removeDialog,
      });
      break;
    default:
      dialog.setProps({
        ...dialogConfig,
        onSubmit: removeDialog,
        onClose: removeDialog,
      });
  }
};

export default {
  alert: genMsgFun({ closeButton: false, cancelButton: false }),
  confirm: genMsgFun({ needReject: true }),
  notation: genMsgFun({
    useNewUI: false,
    type: 'normal',
    cancelButton: false,
    submitLabel: '我知道了',
    className: 'mg-modal mg-notation-modal spaui-dialog-confirm-normal',
  }),
  showLoading,
  hideLoading,
  handleErrResponse,
};
